import { ChangeDetectionStrategy, Component, Injector, Input, ViewEncapsulation } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AppTextService } from '@fi-shared/app-text';
import { FiContactInformationTypes } from '@fi-shared/types/fi-contact-information-types';
import { FiCustomValidatorPatterns } from '@fi-shared/fi-custom-validator-patterns/fi-custom-validator-patterns';
import { IContactModel } from '@fi-shared/models/common';
import { IFiUniqueContactData } from '@fi-shared/fi-directives/fi-custom-validators/fi-unique-contact-async-validator.directive';
import { FiContactsBaseDirective } from '@fi-shared/fi-contacts/fi-contacts-base.directive';
import { DataFieldPropertyType } from '@fi-app/data-field/data-field-property-type';
import { isDefined } from '@fi-shared/utils';
import { IFiContactData } from '@fi-shared/fi-contacts/fi-contacts';

@Component({
    selector: 'fi-email-address-contacts',
    templateUrl: './email-address-contacts.component.html',
    styleUrls: ['./email-address-contacts.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: EmailAddressContactsComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: EmailAddressContactsComponent,
        },
    ],
    host: {
        '(click)': 'onTouched()',
        class: 'fi-email-address-contacts',
    },
    standalone: false,
})
export class EmailAddressContactsComponent extends FiContactsBaseDirective {
    @Input() dataForUniqueEmailCheck: (contact: IContactModel) => IFiUniqueContactData;

    get emailAddresses(): IContactModel[] {
        return this.ngModel;
    }

    FiCustomValidatorPatterns = FiCustomValidatorPatterns;
    readonly dataFieldPropertyType = DataFieldPropertyType.EmailAddress;

    constructor(
        private injector: Injector,
        private appTextService: AppTextService,
    ) {
        super(injector);
    }

    getContactTypesFn: () => FiContactInformationTypes[] = () => {
        return this.contactService.getEmailTypes();
    };

    isContactSignInTypeFn: () => boolean = () => {
        return this.fiUserSignInSettings?.isEmailSignInType();
    };

    getContactTypeName: (contactType: FiContactInformationTypes) => string = (
        contactType: FiContactInformationTypes,
    ) => {
        switch (contactType) {
            /*case FiContactInformationTypes.ImportedEmailAddress:
                return this.appTextService.get('common.imported');*/
            case FiContactInformationTypes.WorkEmailAddress:
                return this.appTextService.get('common.work');
            case FiContactInformationTypes.PrivateEmailAddress:
                return this.appTextService.get('task.private');
            case FiContactInformationTypes.OtherEmailAddress:
                return this.appTextService.get('common.other');
            default:
                return this.contactService.getContactTypeName(contactType);
        }
    };

    getNextNewContactTypeFn: () => FiContactInformationTypes = () => {
        if (!this.isContactTypeChosen(FiContactInformationTypes.WorkEmailAddress))
            return FiContactInformationTypes.WorkEmailAddress;

        if (!this.isContactTypeChosen(FiContactInformationTypes.PrivateEmailAddress))
            return FiContactInformationTypes.PrivateEmailAddress;

        return FiContactInformationTypes.OtherEmailAddress;
    };

    getDataForUniqueEmailCheck(emailAddress: IContactModel): IFiUniqueContactData {
        return isDefined(this.dataForUniqueEmailCheck) ? this.dataForUniqueEmailCheck(emailAddress) : undefined;
    }
}
